import { Typography } from '@apostrophe/ui';
import AutoRefill from 'icons/AutoRefills';
import styled, { css } from 'styled-components';
import {
	media,variables
} from 'styledComponents/utils';


export const OuterContainer = styled.div`
  margin: 26px -15px 10px;
  background-color: ${variables.lightMint};

  ${media.tablet`
    margin: 26px auto;
  `}
`;

export const SavingsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 26px 25px;

  p {
    margin: 0;
    color: ${variables.darkGrey};
    font-weight: bold;
  }

  .flex-start {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    p {
      margin-right: 2px;
    }
  }

  ${media.tablet`
    padding: 26px 15px;
  `}

  ${media.desktop`
    padding: 17px 11px;

    p {
      font-size: 13px;
    }

    svg {
      height: 20px;
      width: 20px;
    }
  `}
`;


export const AutoRefillIcon = styled(AutoRefill)`
  height: 24px;
  width: 24px;
  margin-right: 5px;
  g {
    stroke: ${variables.darkGrey};
  }

  &.green {
    g {
      stroke: ${variables.lightMint};
    }
  }
`;

export const TotalWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;

export const CartItemWrapper = styled.div`
  ${props => props.$type === 'kit_savings' && css`
    color: #80cfc2;
  `};
  ${props => props.$type === 'prescription_savings' && css`
    color: ${({ theme }) => theme.colors.teal.dark};
  `};
  ${props => props.$type === 'buy_more_savings' && css`
    color: ${({ theme }) => theme.colors.teal.dark};  
  `}
  ${props => props.$type === 'promo' && css`
    color: ${({ theme }) => theme.colors.teal.dark};
  `};
  ${props => props.$type === 'promo' && props.$isFollowup && css`
    color: ${({ theme }) => theme.colors.teal.dark};
  `};
  ${props => props.$type === 'free_visit' && props.$isFollowup && css`
    color: ${({ theme }) => theme.colors.teal.dark};
  `};
  ${props => props.$type === 'shipping' && css`
    color: ${({ theme }) => theme.colors.teal.dark};
  `};
  .cart-item {
    display: flex;
    padding: 24px 0;
    justify-content: space-between;
    ${props => props.$medCheckout && css`
      padding-left: 0 !important;
      padding-right: 0 !important;
    `}
  }
  .cart-item-total {
    background-color: white;
    ${props => props.$medCheckout && css`
      font-size: 16px !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
      margin-bottom: 10px;
    `}
  }

  ${media.desktop`
    .cart-item {
      padding: 24px 16px;
      font-size: 16px;
    }
    .cart-item-total {
      font-size: 16px;
    }
  `}
`;

export const ItemsContainer = styled.div`
    hr {
      color: #F4F5F5;
    }

`;

export const CadenceCheckoutText = styled(Typography).attrs({ variant: 'subtitle1' })`
  .bold{
    weight: medium
  }
`;
